import "./About.css";
import Cta from "./Cta";
import { MapPin } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import Footer from "./Footer";
import Testimonial from "./components/Testimonial";
import Slider from "./components/Slider";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const About = () => {
     const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

  return (
    <>

       <Helmet>
                  <meta name="title" content="About | Get Next Visa - AI Powered Student Visa Report" />
                <title>About | Get Next Visa - AI Powered Student Visa Report</title>
                <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
              </Helmet>

      {/* section 1 */}

<div className="mission-container">
  <div className="content-wrapper">
    <h1 className="main-heading1">
      We’re on a Mission to Transform
      <span className="highlight-text"> Immigration Consulting</span>
    </h1>
    <p className="subheading">
      Tired of cookie-cutter advice and hidden commissions? At Get Next Visa,
      our AI-powered platform delivers honest, personalized study-abroad
      guidance that puts your goals first—no upsells, just clear, data-driven
      plans.
    </p>
    <div className="slider-container">
      <div className="slider-track">
        {/* Original Cards */}
        <div className="testimonial-card">
          <div className="avatar-container">
            <div className="avatarr">
                <img className="avatar-inner" src='/photos/Karanvir.webp' alt='student visa' loading="lazy" />
            </div>
            <blockquote className="quote">
              “I would Like to thank the Get Next Visa Team, How they helped me achieve my dreams of studying abroad. Their AI Report was incredibly detailed and accurate. I would recommend them to everyone!”
            </blockquote>
          </div>
          <div className="attribution">— Kanveer Singh, Student</div>
        </div>
        <div className="testimonial-card">
          <div className="avatar-container">
            <div className="avatarr">
              <img className="avatar-inner" src='/photos/priya.webp' alt='work permit' loading="lazy" />
            </div>
            <blockquote className="quote">
              "I saw their ad on Instagram and was impressed by their AI-powered approach. The personalized report helped me find the right university without any hidden fees. Highly recommended!"
            </blockquote>
          </div>
          <div className="attribution">— Priya Sharma, Student</div>
        </div>
        <div className="testimonial-card">
          <div className="avatar-container">
            <div className="avatarr">
             <img className="avatar-inner" src='/photos/amit.webp' alt='ilets and ilets exam' loading="lazy" />

            </div>
            <blockquote className="quote">
              "Finally, an honest and transparent service for students. The
              AI-powered tools are incredibly helpful and easy to use."
            </blockquote>
          </div>
          <div className="attribution">— Amit Patel, Parent</div>
        </div>
        {/* Duplicated Cards for infinite scroll */}
         <div className="testimonial-card">
          <div className="avatar-container">
            <div className="avatarr">
                <img className="avatar-inner" src='/photos/Karanvir.webp' alt='canada education visa' loading="lazy" />
            </div>
            <blockquote className="quote">
              “I would Like to thank the Get Next Visa Team, How they helped me achieve my dreams of studying abroad. Their AI Report was incredibly detailed and accurate. I would recommend them to everyone!”
            </blockquote>
          </div>
          <div className="attribution">— Kanveer Singh, Student</div>
        </div>
        <div className="testimonial-card">
          <div className="avatar-container">
            <div className="avatarr">
              <img className="avatar-inner" src='/photos/priya.webp' alt='education visa requirement' loading="lazy" />
            </div>
            <blockquote className="quote">
              "I saw their ad on Instagram and was impressed by their AI-powered approach. The personalized report helped me find the right university without any hidden fees. Highly recommended!"
            </blockquote>
          </div>
          <div className="attribution">— Priya Sharma, Student</div>
        </div>
        <div className="testimonial-card">
          <div className="avatar-container">
            <div className="avatarr">
             <img className="avatar-inner" src='/photos/amit.webp' alt='education visa documents required' loading="lazy" />

            </div>
            <blockquote className="quote">
              "Finally, an honest and transparent service for students. The
              AI-powered tools are incredibly helpful and easy to use."
            </blockquote>
          </div>
          <div className="attribution">— Amit Patel, Parent</div>
        </div>
      </div>
    </div>
  </div>
</div>



      {/* section 2 */}
<div className="problem-section">
      <div className="problem-container">
        <div className="content-section">
          <h2 className="section-title">The Problem We Saw</h2>
          <div className="problem-list">
            <div className="problem-item">
              <div className="problem-indicator biased" />
              <div className="problem-content">
                <h3 className="problem-title">Commission‑Driven Advice</h3>
                <p className="problem-description">
                  Agents often steer you toward universities that pay them the most—not the ones that fit your goals.
                </p>
              </div>
            </div>
            <div className="problem-item">
              <div className="problem-indicator outdated" />
              <div className="problem-content">
                <h3 className="problem-title">Stale Visa & Program Data</h3>
                <p className="problem-description">
                  Immigration rules and campus offerings change every month. Most advisors rely on outdated PDFs and manual research.
                </p>
              </div>
            </div>
            <div className="problem-item">
              <div className="problem-indicator expensive" />
              <div className="problem-content">
                <h3 className="problem-title">High Costs, Low Access</h3>
                <p className="problem-description">
                  Quality study‑abroad guidance can exceed ₹50,000 and is usually only available in metro cities, leaving thousands without support.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="image-section">
          <img src='/photos/ah2.webp' alt='UK education visa requirement' loading="lazy" />
        </div>
      </div>
</div>
      {/* section 3 */}
      <div className='our-ai'>
        <div className="column-reverse">
          <div className="image-section">
            <img src='/photos/ah5.webp' alt='UK education visa documents required' loading="lazy" />
          </div>

          <div className="content-section">
            <h2 className="section-title">Our Solution</h2>
            <div className="problem-list">
              <div className="problem-item">
                <div className="problem-indicator biased" />
                <div className="problem-content">
                  <h3 className="problem-title">Smart AI Matching</h3>
                  <p className="problem-description">
                  Let our algorithm instantly shortlist the perfect universities for your profile—no hidden agendas, just best‑fit options.
                  </p>
                </div>
              </div>
              <div className="problem-item">
                <div className="problem-indicator outdated" />
                <div className="problem-content">
                  <h3 className="problem-title">Up‑to‑the‑Minute Insights</h3>
                  <p className="problem-description">
                   We pull live data on admissions, visa rules, and career trends so you always get the latest, most accurate advice.
                  </p>
                </div>
              </div>
              <div className="problem-item">
                <div className="problem-indicator expensive" />
                <div className="problem-content">
                  <h3 className="problem-title">Wallet‑Friendly Access </h3>
                  <p className="problem-description">
                    Quality guidance starting at just ₹100—bringing expert study‑abroad support to students everywhere.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* section 4 */}
<div className="problem-section">
      <div className="journey-container">
        <div className="journey-header">
          <h1 className="journey-title">Our Journey</h1>
          <p className="journey-subtitle">
            From frustration to solution - how we built Get Next Visa
          </p>
        </div>
        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-marker">20</div>
            <div className="timeline-content">
              <h3 className="timeline-title">2020 – The Problem Identified </h3>
              <p className="timeline-description">
                After helping hundreds of students manually, our founder saw the broken system — biased advice, high consultancy fees, and outdated visa information.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker">21</div>
            <div className="timeline-content">
              <h3 className="timeline-title">2021 – Building the Solution </h3>
              <p className="timeline-description">
                We began developing Get Next Visa — an AI-powered platform built with data scientists and immigration experts to offer unbiased, personalized guidance.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker">22</div>
            <div className="timeline-content">
              <h3 className="timeline-title">2022 – First 1,000 Students </h3>
              <p className="timeline-description">
                We launched our beta version and helped 1,000 students plan their study abroad journey using AI-generated reports — achieving a 94% satisfaction rate.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker">23</div>
            <div className="timeline-content">
              <h3 className="timeline-title">2023 – Global Expansion </h3>
              <p className="timeline-description">
                We scaled to support 50+ countries and 1,000+ universities — becoming one of India’s most trusted immigration platforms for students.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-marker">24</div>
            <div className="timeline-content">
              <h3 className="timeline-title">2024 – 10,000+ Success Stories </h3>
              <p className="timeline-description">
                With over 10,000 Indian students helped and a 95% success rate, we proved that AI-powered, commission-free visa planning works — and puts students first.
              </p>
            </div>
          </div>
        </div>
      </div>
</div>

      {/* section 5 */}
      {/* <div className='our-ai'>
        <div className="values-container">
          <div className="values-header">
            <h1 className="values-title">What Drives Us </h1>
            <p className="values-subtitle">
              Our values aren't just beliefs — they’re decisions we make every single day.
            </p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-header">
                <div className="value-icon">
                  <img src='/photos/po1.png' alt="Students Before Profits" loading="lazy" />
                </div>
                <h3 className="value-title">Students Before Profits</h3>
              </div>
              <p className="value-description">
                Every decision starts with one question: “Is this best for the student?”
              </p>
              <div className="value-action">
                <p className="action-text">
                  <b>In action:</b>We rejected a ₹16 Cr partnership that didn't align with student-first ethics.

                </p>
              </div>
            </div>
            <div className="value-card">
              <div className="value-header">
                <div className="value-icon">
                  <img src='/photos/po2.png' alt="Built on Transparency" loading="lazy" />

                </div>
                <h3 className="value-title">Built on Transparency </h3>
              </div>
              <p className="value-description">
                No commissions. No hidden college deals. Just honest, data-driven advice.
              </p>
              <div className="value-action">
                <p className="action-text">
                  <b>In action:</b>We publish our matching logic and data sources openly — no filters.
                </p>
              </div>
            </div>
            <div className="value-card">
              <div className="value-header">
                <div className="value-icon">
                  <img src='/photos/po3.png' alt="Access for Every Student" loading="lazy" />

                </div>
                <h3 className="value-title">Access for Every Student </h3>
              </div>
              <p className="value-description">
                Studying abroad shouldn't be only for the privileged few.
              </p>
              <div className="value-action">
                <p className="action-text">
                  <b>In action:</b> We provide free reports and scholarships for students from underserved communities.
                </p>
              </div>
            </div>
            <div className="value-card">
              <div className="value-header">
                <div className="value-icon">
                  <img src='/photos/po4.png' alt="Collaboration Over Competition" loading="lazy" />

                </div>
                <h3 className="value-title">Collaboration Over Competition </h3>
              </div>
              <p className="value-description">
                We believe in building an open ecosystem, not beating the competition.
              </p>
              <div className="value-action">
                <p className="action-text">
                  <b>In action:</b> We open-sourced our college database and share tools with educators.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}


      {/* section 5.1 */}

      <div id="main-container">
        <div className="gnv-create-container">
          <div className="gnv-create-header">
            {/* <div className="gnv-tagline">WHY AICON SYSTEMS</div> */}
            <h1>
             What Drives Us
            </h1>
          </div>
          <main className="gnv-main-content">
            <section className="gnv-creates-grid">
              <aside className="gnv-intro-text">
                <p>Are you ready for the Industrial Metaverse?</p>
                <p>
                  Our core values shape everything we do—transparent, student‑focused, and accessible.
                </p>
                {/* <p className="gnv-highlight">
                  It's not magic, it's just fresh and disruptive engineering.
                </p> */}
              </aside>
              <div className="gnv-create-card">
                <div className="gnv-create-icon">
                  <svg
                    viewBox="0 0 95 50"
                    xmlns="http://www.w3.org/2000/svg"
                    height="100%"
                  >
                    <g
                      fill="none"
                      stroke="#BE0B32"
                      strokeWidth={2}
                      strokeLinecap="square"
                    >
                      <path d="M10 15 v20 M20 15 v20 M30 15 v20" />
                      <path d="M45 25 h45 l-8 -6 m8 6 l-8 6" />
                    </g>
                  </svg>
                </div>
                <h3>Students First</h3>
                {/* <div className="gnv-subtitle">Be in the driver's seat of automation.</div> */}
                <p>
                   Every recommendation begins with “Is this best for the student?”
                </p>
              </div>
              <div className="gnv-create-card">
                <div className="gnv-create-icon">
                  <svg
                    viewBox="0 0 95 50"
                    xmlns="http://www.w3.org/2000/svg"
                    height="100%"
                  >
                    <g
                      fill="none"
                      stroke="#BE0B32"
                      strokeWidth={2}
                      strokeLinecap="square"
                    >
                      <path d="M10 15 v20 M20 15 v20 M30 15 v20" />
                      <path d="M45 25 h45 l-8 -6 m8 6 l-8 6" />
                    </g>
                  </svg>
                </div>
                <h3>Built Transparency</h3>
                {/* <div className="gnv-subtitle">Be in the driver's seat of automation.</div> */}
                <p>
                  No commissions. No hidden agendas—just clear, data‑backed advice.
                </p>
              </div>
              <div className="gnv-create-card">
                <div className="gnv-create-icon">
                  <svg
                    viewBox="0 0 90 50"
                    xmlns="http://www.w3.org/2000/svg"
                    height="100%"
                  >
                    <g fill="none" stroke="#BE0B32" strokeWidth={2}>
                      <path d="M5 25 h15" />
                      <g strokeLinecap="round">
                        <circle cx={35} cy={18} r="4.5" />
                        <circle cx={35} cy={32} r="4.5" />
                        <circle cx={48} cy={25} r="4.5" />
                        <circle cx={22} cy={25} r="4.5" />
                      </g>
                      <path d="M62 25 h20 l-6-5 m6 5 l-6 5" strokeLinecap="round" />
                    </g>
                  </svg>
                </div>
                <h3>Accessible to All</h3>
                {/* <div className="gnv-subtitle">
                  We challenge what others believe to be inconceivable.
                </div> */}
                <p>
                 Quality study‑abroad planning at student‑friendly rates—anywhere in India.
                </p>
              </div>
              <div className="gnv-create-card">
                <div className="gnv-create-icon">   
                  <svg 
                    viewBox="0 0 95 50"
                    xmlns="http://www.w3.org/2000/svg"
                    height="100%"
                  >
                    <g fill="none" strokeWidth={2}>
                      <path stroke="#BE0B32" d="M5 20 C 25 20, 40 10, 50 25" />
                      <path
                        stroke="#BE0B32"
                        strokeDasharray="4 4"
                        d="M5 30 C 25 30, 40 40, 50 25"
                      ></path>
                      <path
                        stroke="#BE0B32"
                        d="M55 25 h35 l-6-5 m6 5 l-6 5"
                        strokeLinecap="round"
                      ></path>
                    </g>
                  </svg>
                </div>
                <h3>Collaboration Over Competition</h3>
                {/* <div className="gnv-subtitle">
                  More applications than you can think of.
                </div> */}
                <p>
                  We share insights openly because better outcomes happen together.
                </p>
              </div>
            </section>
          </main>
        </div>
      </div>

      {/* section 6 */}

      <div className="team-container">
        <div className="team-wrapper">
          <div className="team-header">
            <h1 className="team-title">
              Meet the Humans Behind the AI
            </h1>
            <p className="team-subtitle">
              We're a diverse team united by one goal: making immigration planning better for everyone
            </p>
          </div>

          <div className="team-grid">
            <div className="team-card">
              <div className="card-headerr">
                <div className="avatar">
                  <span className="avatar-text">
                  <img className="avatar-inner" src='/photos/gurmeet_kandola.webp' alt='australia visa requirements' loading="lazy" /></span>
                </div>
                <div className="member-info">
                  <h3 className="member-name">Gurmeet Kandola</h3>
                  <p className="member-title">Founder & COO</p>
                  <div className="member-location">
                    <MapPin className="location-icon" />
                    <span>Delhi, India</span>
                  </div>
                </div>
                <div className="linkedin-icon">
                </div>
              </div>
              <div className="member-description">
                <p className="description-text">
                  Former immigration consultant who got tired of biased advice and built Get Next Visa to put students first. Loves cricket and chai.</p>
              </div>
              <div className="fun-fact-box">
                <p className="fun-fact-text">
                  <span className="fun-fact-label">🎯 Fun fact: </span>
                  Has visited 25+ countries to study immigration systems firsthand.
                </p>
              </div>
            </div>

            <div className="team-card">
              <div className="card-headerr">
                <div className="avatar">
                  <span className="avatar-text">
                  <img className="avatar-inner" src='/photos/himanshi_negi.webp' alt='australia visa documents required' loading="lazy" /></span>
                </div>
                <div className="member-info">
                  <h3 className="member-name">Himanshi Negi</h3>
                  <p className="member-title">Founder & Head of AI Research</p>
                  <div className="member-location">
                    <MapPin className="location-icon" />
                    <span>Chandigarh, India</span>
                  </div>
                </div>
                <div className="linkedin-icon">
                </div>
              </div>
              <div className="member-description">
                <p className="description-text">
                  MBA graduate with a passion for AI and its applications in education. She believes in leveraging technology to enhance learning experiences.
                </p>
              </div>
              <div className="fun-fact-box">
                <p className="fun-fact-text">
                  <span className="fun-fact-label">🎯 Fun fact: </span>
                  Built her first recommendation engine at age 16 for her school’s library.
                </p>
              </div>
            </div>

            <div className="team-card">
              <div className="card-headerr">
                <div className="avatar">
                  <span className="avatar-text">
                  <img className="avatar-inner" src='/photos/harkaran_singh.png' alt='Newzeland Visa requirements' loading="lazy" /></span>
                </div>
                <div className="member-info">
                  <h3 className="member-name">Harkaran Singh</h3>
                  <p className="member-title">Founder & CTO</p>
                  <div className="member-location">
                    <MapPin className="location-icon" />
                    <span>Punjab, India</span>
                  </div>
                </div>
                <div className="linkedin-icon">
                </div>
              </div>
              <div className="member-description">
                <p className="description-text">
                  Worked with Companies like OYO, Oberoi Hotels and Code Brew Labs. Passionate about building scalable tech solutions that make a difference.
                </p>
              </div>
              <div className="fun-fact-box">
                <p className="fun-fact-text">
                  <span className="fun-fact-label">🎯 Fun fact: </span>
                  Speaks 5 languages and has helped students from 40+ countries.</p>
              </div>
            </div>

            <div className="team-card">
              <div className="card-headerr">
                <div className="avatar">
                  <span className="avatar-text">
                  <img className="avatar-inner" src='/photos/rahil_sahni.webp' alt='Newzeland Visa documents required' loading="lazy" /></span>
                </div>
                <div className="member-info">
                  <h3 className="member-name">Rahil Sahni</h3>
                  <p className="member-title">Student Success Manager</p>
                  <div className="member-location">
                    <MapPin className="location-icon" />
                    <span>Toronto, Canada</span>
                  </div>
                </div>
                <div className="linkedin-icon">
                </div>
              </div>
              <div className="member-description">
                <p className="description-text">
                  Former international student turned guide for others. Helps students through every step of their study abroad journey. </p>
              </div>
              <div className="fun-fact-box">
                <p className="fun-fact-text">
                  <span className="fun-fact-label">🎯 Fun fact: </span>
                  Maintains personal relationships with over 500 platform alumni. </p>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* section 7 */}


      <Cta />

      {/* <Footer /> */}

    </>
  )
}

export default About